$(document).ready(function () {
  $('#copySponsorshipCode').on('click', function () {
    if (!navigator.clipboard) {
      $('#sponsorship_code').select();
      document.execCommand('copy');
    } else {
      var text_to_copy = $('#sponsorship_code').val();
      navigator.clipboard.writeText(text_to_copy);
    }

    var currentLocale = getCurrentLocale();
    var successMessage = { fr: 'Code copié', en: 'Code copied' };

    toastr.success(successMessage[currentLocale]);
  });

  const sponsorshipInput = document.getElementById(
    'user_natural_profile_attributes_sponsor_code'
  );

  const debounceSponsorshipCode = createDebouncer();

  sponsorshipInput?.addEventListener(
    'input',
    function(event) {
      const value = event.target.value;
      debounceSponsorshipCode(() => {
        verifySponsorshipCode(value);
      }, 500);
    }
  );

  function verifySponsorshipCode(code) {
    if (code.length == 0) {
      sponsorshipInput.classList.remove('success-input');
      sponsorshipInput.classList.remove('danger-input');
      return;
    }

    const params = { code: code };
    const endpoint = '/users/profiles/sponsorships';
    const paramsString = new URLSearchParams(params).toString();

    fetch(`${endpoint}?${paramsString}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response.ok) {
          sponsorshipInput.classList.remove('danger-input');
          sponsorshipInput.classList.add('success-input');
        } else {
          sponsorshipInput.classList.remove('success-input');
          sponsorshipInput.classList.add('danger-input');
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
});
